import { useCallback, useEffect } from 'react'
import getScrollBarWidth from 'common/helpers/getters/getScrollBarWidth'
import getPageOffset from 'common/helpers/getters/getPageOffset'

import useMedia from './useMedia'


let openedModalsCount = 0
let savedOffsetTop = 0

const useModalOpened = (enabled = true) => {
  const { isMobile } = useMedia()

  const translateRoot = useCallback((offset) => {
    // can't use transform, because it creates new fixed layer and breaks fixed elements
    document.getElementById('root').style.marginTop = offset ? `${offset}px` : null
  }, [])

  const addStyles = useCallback(() => {
    const offsetTop = getPageOffset().y

    document.body.classList.add('body-modal-opened')
    document.body.style.paddingRight = `${getScrollBarWidth()}px`

    if (isMobile && offsetTop > 0) {
      window.scrollTo(0, 0)
      translateRoot(-offsetTop)
      savedOffsetTop = offsetTop
    }
  }, [ isMobile, translateRoot ])

  const removeStyles = useCallback(() => {
    document.body.classList.remove('body-modal-opened')
    document.body.style.paddingRight = '0px'

    if (isMobile && savedOffsetTop > 0) {
      translateRoot(0)
      window.scrollTo(0, savedOffsetTop)
      savedOffsetTop = 0
    }
  }, [ isMobile, translateRoot ])

  useEffect(() => {
    if (enabled) {
      if (openedModalsCount === 0) {
        addStyles()
      }
      openedModalsCount++

      return () => {
        openedModalsCount--

        if (openedModalsCount === 0) {
          removeStyles()
        }
      }
    }
  }, [ addStyles, removeStyles, enabled ])
}


export default useModalOpened
